import { message } from 'antd';
import { txt } from 'libs/i18n';
import { Speaker } from 'api/speaker';
import { addSpeaker, deleteSpeaker, fetchSpeaker, updateSpeaker, } from 'api/speaker-api-v2';
import { buildSpeakerWithUpdatedVariantsAndRoles } from './speaker-utils';
export const createSpeaker = async (connection, speaker, availability, localization) => {
    if (availability === 'all') {
        const body = {
            firstName: speaker.firstName,
            lastName: speaker.lastName,
            role: speaker.role,
            localization: speaker.localization,
            speakerIdActive: speaker.speakerIdActive,
            imageBase64: speaker.imageBase64,
            customData: {
                captionColor: speaker.captionColor,
                isDefaultColor: speaker.isDefaultColor,
            },
        };
        const result = await addSpeaker(connection, body);
        if (result.isSuccess()) {
            return Speaker.fromSpeakerData(result.get(), null);
        }
        void message.error(txt('unexpectedError'));
        return null;
    }
    return new Speaker(speaker.firstName, speaker.lastName.trim(), speaker.role, null, null, null, false, localization, new Map(), speaker.captionColor, speaker.isDefaultColor);
};
export const addLocalizationToSpeaker = async (connection, duplicateSpeaker, localization, speakerIdActive, speaker) => {
    var _a, _b, _c, _d;
    const newLocalization = {
        speakerIdActive,
        defaultVariantIndex: 0,
        nameVariants: [
            {
                firstName: (_a = speaker.firstName) !== null && _a !== void 0 ? _a : '',
                lastName: speaker.lastName,
                roles: speaker.role != null ? [speaker.role] : [],
                defaultRoleIndex: speaker.role != null ? 0 : -1,
            },
        ],
    };
    const { neutralData, localizations } = duplicateSpeaker;
    const body = {
        localizations: Object.assign(Object.assign({}, localizations), { [localization !== null && localization !== void 0 ? localization : neutralData.defaultLocalisation]: newLocalization }),
        defaultLocalisation: neutralData.defaultLocalisation,
        imageBase64: (_b = speaker.imageBase64) !== null && _b !== void 0 ? _b : neutralData.imageBase64,
        customData: Object.assign(Object.assign({}, neutralData.customData), { captionColor: (_c = speaker.captionColor) !== null && _c !== void 0 ? _c : neutralData.customData.captionColor, isDefaultColor: (_d = speaker.isDefaultColor) !== null && _d !== void 0 ? _d : neutralData.customData.isDefaultColor }),
        concurrencyToken: duplicateSpeaker.concurrencyToken,
    };
    const result = await updateSpeaker(connection, duplicateSpeaker.neutralData.uniqueId, body);
    if (result.isSuccess()) {
        return Speaker.fromSpeakerData(result.get(), localization);
    }
    void message.error(txt('unexpectedError'));
    return null;
};
export const editSpeaker = async (connection, speaker, role, availability, dbSpeaker, langCode, nameVariants, nameVariant, imageBase64, speakerIdActive) => {
    var _a, _b, _c, _d, _e, _f;
    const firstName = (_c = (_b = (_a = nameVariant === null || nameVariant === void 0 ? void 0 : nameVariant.values) === null || _a === void 0 ? void 0 : _a.firstName) !== null && _b !== void 0 ? _b : speaker.firstName) !== null && _c !== void 0 ? _c : '';
    const lastName = (_e = (_d = nameVariant === null || nameVariant === void 0 ? void 0 : nameVariant.values) === null || _d === void 0 ? void 0 : _d.lastName) !== null && _e !== void 0 ? _e : speaker.lastName;
    const editedSpeaker = new Speaker(firstName, lastName, (_f = role === null || role === void 0 ? void 0 : role.label) !== null && _f !== void 0 ? _f : null, speaker.id, speaker.dbid, speaker.diarizationCode, speaker.isUnknown, speaker.language, speaker.unmaintainedMetadata, speaker.captionColor, speaker.isDefaultColor);
    if (availability === 'current') {
        return editedSpeaker;
    }
    if (dbSpeaker === null) {
        return null;
    }
    const code = langCode !== null && langCode !== void 0 ? langCode : dbSpeaker.neutralData.defaultLocalisation;
    const updatedData = buildSpeakerWithUpdatedVariantsAndRoles(dbSpeaker, code, nameVariants, speakerIdActive);
    const body = {
        localizations: updatedData.localizations,
        defaultLocalisation: updatedData.neutralData.defaultLocalisation,
        imageBase64: imageBase64 !== undefined
            ? imageBase64
            : updatedData.neutralData.imageBase64,
        customData: Object.assign(Object.assign(Object.assign({}, updatedData.neutralData.customData), (speaker.captionColor != null && { captionColor: speaker.captionColor })), { isDefaultColor: speaker.isDefaultColor }),
        concurrencyToken: updatedData.concurrencyToken,
    };
    const result = await updateSpeaker(connection, dbSpeaker.neutralData.uniqueId, body);
    if (result.isSuccess()) {
        return editedSpeaker;
    }
    void message.error(txt('unexpectedError'));
    return null;
};
export const deleteSpeakerLocalization = async (connection, speakerUniqueId, localizationCode) => {
    if (localizationCode === undefined) {
        return false;
    }
    const fetchResult = await fetchSpeaker(connection, speakerUniqueId);
    if (!fetchResult.isSuccess()) {
        void message.error(txt('unexpectedError'));
        return false;
    }
    const dbSpeaker = fetchResult.get();
    const remainingLocalizations = Object.fromEntries(Object.entries(dbSpeaker.localizations).filter(([code]) => code !== localizationCode));
    if (Object.keys(remainingLocalizations).length === 0) {
        const result = await deleteSpeaker(connection, speakerUniqueId);
        if (result.isSuccess()) {
            return true;
        }
        void message.error(txt('unexpectedError'));
        return false;
    }
    const body = {
        localizations: remainingLocalizations,
        defaultLocalisation: dbSpeaker.neutralData.defaultLocalisation,
        imageBase64: dbSpeaker.neutralData.imageBase64,
        customData: dbSpeaker.neutralData.customData,
        concurrencyToken: dbSpeaker.concurrencyToken,
    };
    const result = await updateSpeaker(connection, speakerUniqueId, body);
    if (result.isSuccess()) {
        return true;
    }
    void message.error(txt('unexpectedError'));
    return false;
};
